import React, { useContext, useState, useEffect } from "react";
import News_IMG1 from "../images/news.jpg";
import News_IMG2 from "../images/news1.jpg";
import News_IMG3 from "../images/news2.jpg";
import News_IMG4 from "../images/news3.jpg";
import News_IMG5 from "../images/news4.jpg";
import News_IMG6 from "../images/news5.jpg";
import Banner from "../images/banner.jpg";
import AOS from "aos";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import BannerNewSection from "../inc/BannerNewsSection";
import { Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import ApiService from "../../utility/services/ApiService";
import NoDataFoundIcon2 from "../images/no_result_in_state.gif";
import ConstConfig from "../../utility/configs/constConfig";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const News = () => {
  const { setAuthRole, user } = useContext(AuthContext);
  const { enctyptDataFun, consoleService, formet_date } = Functions();
  const { get_news_list, get_news_category_list } = ApiService();

  // LOGICAL VARIABLES
  React.useEffect(() => {
    trackScreenView("news_screen", { screen_name: "News", ...getUserTrackingParams(user) });
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const list_limit = 12;
  const all_category_tag = "All Categories";
  const [activeCategory, setActiveCategory] = useState(all_category_tag);
  const [active_category_id, setActiveCategoryId] = useState("");
  const [news_list, setNewList] = useState([]);
  const [category_list, setCategoryList] = useState([]);
  const [initial_loading, setInitialLoading] = useState(false);

  const [show_loadmore_btn, setShowLoadmoreBtn] = useState(false);

  const new_list_length = news_list.length;
  const isListFound = new_list_length > 0;
  const isDataNotFound = !isListFound && initial_loading;

  const handleCategoryClick = ({ title, category_id }) => {
    setActiveCategory(title);
    setActiveCategoryId(category_id);
    fetch_list_by_category(category_id);
  };

  const { setLoading } = useContext(AuthContext);

  useEffect(() => {
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const category_res = await get_news_category_list();
      if (!(category_res.status === 1 && category_res.data.length > 0)) return;
      const res = await get_news_list({ page: 1 });
      if (res.status === 1) {
        setCategoryList([...category_res.data]);
        const listData = res.data;
        setNewList([...listData.new_list]);
        const current_page = 1;
        const totalItems = listData.total_items;
        const totalPages = Math.ceil(totalItems / list_limit);
        const showMoreButton = current_page < totalPages;
        setShowLoadmoreBtn(showMoreButton);

        setInitialLoading(true);
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }

  async function fetch_list_by_category(category_id) {
    try {
      setLoading(true);
      const res = await get_news_list({ page: 1, category_id });

      if (res.status === 1) {
        const listData = res.data;
        setNewList([...listData.new_list]);
        const current_page = 1;
        const totalItems = listData.total_items;
        const totalPages = Math.ceil(totalItems / list_limit);

        const showMoreButton = current_page < totalPages;
        setShowLoadmoreBtn(showMoreButton);

        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }

  function get_page_number() {
    const total_items = news_list.length;
    const limit = list_limit;

    const divided_val = total_items / limit;

    let pageNumber = Math.ceil(divided_val);

    const isDecimal = divided_val % 1 !== 0;

    if (!isDecimal) {
      pageNumber += 1;
    }

    return pageNumber;
  }

  async function loadmore_news() {
    try {
      setLoading(true);

      const pageNumber = get_page_number();

      const res = await get_news_list({
        page: pageNumber,
        category_id: active_category_id,
      });

      if (res.status === 1) {
        const listData = res.data;
        const isListFound = listData.new_list.length > 0;
        const current_page = pageNumber;
        const totalItems = listData.total_items;
        const totalPages = Math.ceil(totalItems / list_limit);
        const showMoreButton = current_page < totalPages;
        setShowLoadmoreBtn(showMoreButton);

        if (!isListFound) {
          return setLoading(false);
        }

        setNewList([...news_list, ...listData.new_list]);

        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in loadmore_news fun = ", err);
    }
  }

  return (
    <>
      <BannerNewSection
        banner={Banner}
        name={"Home"}
        title={"News"}
        tabs={
          <div className="tabsBanner">
            <Link
              className={activeCategory === all_category_tag ? "active" : ""}
              to={"javascript:void(0)"}
              onClick={() =>
                handleCategoryClick({
                  title: all_category_tag,
                  category_id: "",
                })
              }
            >
              All Categories
            </Link>
            {category_list.map((item) => {
              const title = item.title;
              return (
                <Link
                  className={activeCategory === title ? "active" : ""}
                  to={"javascript:void(0)"}
                  onClick={() =>
                    handleCategoryClick({ title, category_id: item._id })
                  }
                >
                  {title}
                </Link>
              );
            })}
          </div>
        }
        style={{
          paddingBottom: "3em",
        }}
      />
      <section id="about" className="py-5">
        <div className="container">
          <div className="row">
            {isDataNotFound ? (
              // IF DATA NOT FOUND
              <view
                className="bird_gif"
                style={{
                  height: "40vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                {/* <Image
                  src={NoDataFoundIcon2}
                  alt="No Data Found"
                  className="img-fluid noFoundImg3"
                /> */}
                <span className="searchgif_txt">No Data Found</span>
              </view>
            ) : (
              // IF DATA FOUND
              <>
                {news_list.map((item) => (
                  <Link
                    onClick={() => {
                      window.open(`/blogpost/${item._id}`);
                    }}
                    className="col-lg-4 col-xl-4 col-sm-6 col-md-6 col-12 mb-3 linkBlog"
                    key={item._id}
                  >
                    <div className="news_box">
                      <Image
                        src={`${ConstConfig.IMAGE_URL}/${item.thumbnail_img}`}
                        alt=""
                      />
                      <div className="news_Flex">
                        <span className="badge ">{item.category_title}</span>
                        <span className="time">
                          {formet_date(item.created_at)}
                        </span>
                      </div>
                      {/* <Link to={"/blogpost"} className="linkBlog">
                    <p>{item.description}</p>
                  </Link> */}
                      <p className="clamp">{item.title}</p>
                    </div>
                  </Link>
                ))}

                {show_loadmore_btn && (
                  <div className="seeMore">
                    <Button
                      variant="outline-primary"
                      onClick={() => {
                        loadmore_news();
                      }}
                    >
                      See More
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default News;
